// MEMBERTIER1 / MEMBERPRICE1: which shelf tier is "Member". Kept free of server imports so the browser setup checklist
// (ui/src/admin.ts) and the member comp ceiling (memberPricing.ts) decide it with the same code.

/** The names a location gives the shelf tier a member pays: "Member" (the
 * original name) or "Member Shelf" (SHELFDEFAULT1, DEC-589). Matched
 * case-insensitively and trimmed, because it is a free-text field an
 * Admin types. */
const MEMBER_SHELF_TIER_NAMES: readonly string[] = ["member shelf", "member"];

/** MEMBERTIER1: the one place that decides which shelf tier is "Member".
 * Considers ACTIVE tiers only (DEC-128 Ruling 2). When both a "Member Shelf"
 * and a "Member" tier are active, the exact "Member Shelf" one wins. Any
 * other code that needs the member tier by name must call this. */
export function findMemberShelfTier<T extends { readonly label: string; readonly active: boolean }>(
  tiers: readonly T[],
): T | undefined {
  const normalized = (tier: T): string => tier.label.trim().toLowerCase();
  for (const name of MEMBER_SHELF_TIER_NAMES) {
    const found = tiers.find((tier) => tier.active && normalized(tier) === name);
    if (found !== undefined) return found;
  }
  return undefined;
}
